import { render, staticRenderFns } from "./BasicV2.vue?vue&type=template&id=742f05f3&scoped=true"
import script from "./BasicV2.vue?vue&type=script&lang=js"
export * from "./BasicV2.vue?vue&type=script&lang=js"
import style0 from "./BasicV2.vue?vue&type=style&index=0&id=742f05f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f05f3",
  null
  
)

export default component.exports